import { Component, Input } from '@angular/core';

@Component({
	selector: 'mb-model-list-empty-container',
	templateUrl: './model-list-empty-container.component.html',
	styleUrls: ['./model-list-empty-container.component.scss']
})
export class ModelListEmptyContainerComponent {
	@Input() public titleDCR: string;
	@Input() public subTextDCR: string;
}
